'use client';

import { ShoppingCart } from 'lucide-react';
import { useCart } from '@/app/context/CartContext';
import Link from 'next/link';

export default function CartIcon() {
  const { totalItems } = useCart();

  return (
    <Link
      href="/cart"
      className="relative p-2 hover:bg-gray-100 rounded-full transition-colors"
      aria-label={totalItems > 0 ? `Panier avec ${totalItems} article${totalItems > 1 ? 's' : ''}` : "Panier vide"}
    >
      <ShoppingCart className="text-gray-600" />
      {totalItems > 0 && (
        <span
          className="absolute -top-1 -right-1 flex h-5 w-5 items-center justify-center rounded-full bg-green-600 text-xs font-bold text-white"
          aria-hidden="true"
        >
          {totalItems}
        </span>
      )}
    </Link>
  );
}
